<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Filter Food Item</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr />

<div mat-dialog-content class="mb-2">
  <div class="w-100 pb-3">
    <nz-select
      nzAllowClear
      [nzShowSearch]="false"
      nzPlaceHolder="Food Item Category"
      [(ngModel)]="selectedCategory"
      (ngModelChange)="onCategory(selectedCategory)"
      class="w-100"
      >
      @for (option of categoryKeyValue; track option) {
        <nz-option
          [nzLabel]="option.label"
          [nzValue]="option.value"
        ></nz-option>
      }
    </nz-select>
  </div>

  <div class="w-100 pb-3">
    <nz-select
      nzAllowClear
      nzMode="multiple"
      [nzShowSearch]="false"
      nzPlaceHolder="Food Item Type"
      [(ngModel)]="selectedType"
      (ngModelChange)="onType(selectedType)"
      class="w-100"
      >
      @for (option of typeKeyValue; track option) {
        <nz-option
          [nzLabel]="option.label"
          [nzValue]="option.value"
        ></nz-option>
      }
    </nz-select>
  </div>

  <div class="w-100 pb-3">
    <nz-select
      nzAllowClear
      nzMode="multiple"
      [nzShowSearch]="false"
      nzPlaceHolder="Search Tag"
      [(ngModel)]="selectedTag"
      (ngModelChange)="onSearchTag(selectedTag)"
      class="w-100"
      >
      @for (option of searchTagKeyValue; track option) {
        <nz-option
          [nzLabel]="option.label"
          [nzValue]="option.value"
        ></nz-option>
      }
    </nz-select>
  </div>
</div>

<div class="d-flex justify-content-end mb-4 me-4">
  <button
    class="small-btn-width btn-radius me-2"
    nzType="primary"
    nzGhost
    nz-button
    mat-dialog-close="true"
    >
    Close
  </button>
  <button
    nz-button
    nzType="primary"
    class="small-btn-width btn-radius"
    (click)="onSubmit()"
    >
    Filter
  </button>
</div>
